import produce from "immer";
import { IStoreState } from "..";
import { LoadState } from "../../constants/enums";
import {
  CLEAR_SINGLE_SERVICE_REQUISITION,
  CLEAR_SERVICE_REQUISITION_STATE,
  FETCH_SERVICE_REQUISITION_APPROVAL_LIST_FAILED,
  FETCH_SERVICE_REQUISITION_APPROVAL_LIST_PROGRESS,
  FETCH_SERVICE_REQUISITION_APPROVAL_LIST_SUCCESS,
  ServiceRequestActions,
  FETCH_SERVICE_REQUISITION_LIST_PROGRESS,
  FETCH_SERVICE_REQUISITION_LIST_SUCCESS,
  FETCH_SERVICE_REQUISITION_LIST_FAILED,
  FETCH_SINGLE_SERVICE_REQUISITION_PROGRESS,
  FETCH_SINGLE_SERVICE_REQUISITION_SUCCESS,
  FETCH_SINGLE_SERVICE_REQUISITION_FAILED,
} from ".";
import {
  defaultServiceRequesition,
  defaultServiceRequesitionState,
} from "./service-request.state";

export const serviceRequesitionReducer = (
  state: IStoreState["serviceRequesition"] = defaultServiceRequesitionState,
  action: ServiceRequestActions,
) => {
  switch (action.type) {
    case FETCH_SERVICE_REQUISITION_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.service_requisition_list.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_SERVICE_REQUISITION_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.service_requisition_list.loading = LoadState.Loaded;
        draftState.service_requisition_list.list = data;
        draftState.service_requisition_list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_SERVICE_REQUISITION_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.service_requisition_list.loading = LoadState.Failed;
      });
      return newState;
    }

    case FETCH_SINGLE_SERVICE_REQUISITION_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.single_service_requisition.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_SINGLE_SERVICE_REQUISITION_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.single_service_requisition.loading = LoadState.Loaded;
        draftState.single_service_requisition.data = data;
      });
      return newState;
    }
    case FETCH_SINGLE_SERVICE_REQUISITION_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.single_service_requisition.loading = LoadState.Failed;
        draftState.single_service_requisition.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_SINGLE_SERVICE_REQUISITION: {
      const newState = produce(state, (draftState) => {
        draftState.single_service_requisition.loading = LoadState.NotLoaded;
        draftState.single_service_requisition.data = defaultServiceRequesition;
      });
      return newState;
    }
    case CLEAR_SERVICE_REQUISITION_STATE: {
      return defaultServiceRequesitionState;
    }

    case FETCH_SERVICE_REQUISITION_APPROVAL_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.service_requisition_approval_list.loading =
          LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_SERVICE_REQUISITION_APPROVAL_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.service_requisition_approval_list.loading = LoadState.Loaded;
        draftState.service_requisition_approval_list.list = data;
        draftState.service_requisition_approval_list.totalRecords =
          totalRecords;
      });
      return newState;
    }
    case FETCH_SERVICE_REQUISITION_APPROVAL_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.service_requisition_approval_list.loading = LoadState.Failed;
      });
      return newState;
    }

    default: {
      return state;
    }
  }
};
